/** @file cropImage: copies a rectangle out of an image; area outside the source is transparent. */
import type { Image } from '../types/image';
import { blitImage } from './blitImage';
import { createImage } from './createImage';

/** A new `w` × `h` image holding `src` from (`x`, `y`); pixels outside `src` are transparent black. */
export function cropImage(src: Image, x: number, y: number, w: number, h: number): Image {
  const out = createImage(w, h);
  blitImage(out, src, -x, -y);
  return out;
}
